

<template>
  <!-- Product Area Start -->
  <section class="product_area">
    <div class="container">
      <div class="row">
        <div class="col-lg-3">
          <div class="product_sidebar">
            <div class="sidebar-widget">
              <div class="single-sidebar">
                <form>
                  <input type="search" placeholder="Search..." v-model="pagination.search" @input="searchProduct"/>
                  <button type="submit" @click.stop.prevent="searchProduct"><i class="fa fa-search"></i></button>
                </form>
              </div>
              <div class="single-sidebar">
                <h3 class="sub_title">Categories</h3>
                <ul class="category">
                  <li v-for="(cat, key) in category" :key="key">
                    <a href="#" @click.stop.prevent="filterByCategory(cat)">{{ cat.name }}</a>
                  </li>
                </ul>
              </div>
              <div class="single-sidebar">
                <h3 class="sub_title">Popular Post</h3>
                <ul class="recent-blog">
                  <li v-for="(product, key) in popularItems" :key="key">
                    <div class="recent-img">
                      <router-link :to="`/shop/product-details/${product.sku}`">
                        <img v-bind:src="require(`@/assets/img/${product.img}`)" alt="recent image">
                      </router-link>
                    </div>
                    <div class="recent-text">
                      <h4>
                        <router-link :to="`/shop/product-details/${product.sku}`">{{ product.title }}</router-link>
                      </h4>
                      <p>£30.00</p>
                      <div class="tour-rating">
                        <ul>
                          <li><i class="fas fa-star"></i></li>
                          <li><i class="fas fa-star"></i></li>
                          <li><i class="fas fa-star"></i></li>
                          <li><i class="fas fa-star"></i></li>
                          <li><i class="far fa-star"></i></li>
                        </ul>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
              <div class="single-sidebar">
                <a href="javascript:;">
                  <img src="../../assets/img/promo_add.jpg" alt="img"/>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-9">
          <div class="product_list_inn">
            <div class="product_list_result">
              <p>Showing 1–{{ pagination.total }} of {{ pagination.total }} results</p>
              <form>
                <select name="orderby" class="orderby" aria-label="Shop order">
                  <option value="popularity">Sort by popularity</option>
                  <option value="rating">Sort by average rating</option>
                  <option value="date" selected="selected">Sort by latest</option>
                  <option value="price">Sort by price: low to high</option>
                  <option value="price-desc">Sort by price: high to low</option>
                </select>
              </form>
            </div>
            <div class="row">
              <div class="col-lg-4 col-sm-6" v-for="(product, key) in products" :key="key">
                <div class="pizza_item">
                  <div class="pizza_slide_img">
                    <img v-bind:src="require(`@/assets/img/${product.img}`)" alt="img"/>
                    <div class="pizza_slide_action">
                      <a href="javascript:;" @click.stop.prevent="addToCart(product)"><i
                        class="fas fa-shopping-cart"></i> Add to cart</a>
                    </div>
                  </div>
                  <div class="pizza_slide_text">
                    <h3>
                      <router-link :to="`/shop/product-details/${product.sku}`">{{ product.title }}</router-link>
                    </h3>
                    <p>{{ product.excerpt }}</p>
                    <h3 class="pizza_slide_price"><span class="currencySymbol">£</span>{{ product.price }}</h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="pagination-box-row">
            <p>Page 1 of {{ pagination.total }}</p>
            <ul class="pagination">
              <li class="active"><a href="#">1</a></li>
              <li><a href="#">2</a></li>
              <li><a href="#">3</a></li>
              <li>...</li>
              <li><a href="#">6</a></li>
              <li><a href="#"><i class="fa fa-angle-double-right"></i></a></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- Product Area End -->
</template>
<script>
import {mapState} from "vuex";

export default {
  name: 'ProductsArea',
  data() {
    return {
      pagination: {
        search: '',
        total: 0,
        itemsPerPage: 9
      }
    }
  },
  computed: {
    ...mapState({
      products: function (state) {
        let products = state.products.items;
        this.pagination.total = products.length;

        return products.filter((item, key) => key <= 8);
      },
      category: function (state) {
        return state.products.category;
      },
      popularItems: function (state) {
        return state.products.popularItems;
      },
    })
  },
  methods: {
    filterByCategory(data) {
      /* Call the product filter action hook and filter by category id */

      this.$store.dispatch('filterProductsByCategory', data.id);
    },
    searchProduct() {
      /* Call the search action hook and search product by user input*/

      let searchValue = this.pagination.search;
      this.$store.dispatch('searchProduct', searchValue);
    },
    addToCart(product) {
      let {sku, cat, title, price, img} = product;

      this.$store.dispatch('addToCart', {sku, cat, title, price, img, total: price, quantity: 1})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/products/ProductsArea.vue